import { configureAnchors } from 'react-scrollable-anchor';

// eslint-disable-next-line react/prefer-stateless-function
class MediaQueryListener {
	static MEDIA_BREAKPOINT_MEDIUM_UP = '(min-width: 768px)';

	registerMediaQueries = () => {
		if (window && window.matchMedia) {
			const mediaQuery = window.matchMedia(MediaQueryListener.MEDIA_BREAKPOINT_MEDIUM_UP);
			mediaQuery.addListener(this.onMediaBreakpointMediumUp);
			// Fire first call
			this.onMediaBreakpointMediumUp(mediaQuery);
		}
	};

	// media query change
	onMediaBreakpointMediumUp(mediaQuery) {
		if (mediaQuery.matches) {
			// window width is at least 768px
			configureAnchors({ offset: -40, scrollDuration: 600 });
		}
		else {
			// window width is less than 768px
			// Offset all anchors by -60 to account for mobile header
			configureAnchors({ offset: -60, scrollDuration: 600 });
		}
	}

}

export default new MediaQueryListener();


// WEBPACK FOOTER //
// ./listeners/MediaQueryListener.js